export function formatHeader(value) {
  return value === 'Patient.CheckIn' ? 'Check-in' : 'Note'
}
